import React from 'react';
import { reduxForm } from 'redux-form';

import Aux from '../../common/Aux';
import Button from '../../common/form/Button';
import { ButtonGroup, InputFieldGroup } from '../../common/form';
import Spinner from '../../common/loaders/Spinner';
import Card from '../../common/Card';

const PasswordForm = ({ handleSubmit, onSubmit, submitting, errorMessage }) => {
	return (
		<Aux>
			{ submitting && <Spinner /> }
			<form onSubmit={handleSubmit(onSubmit)} className="settings__form">

				<InputFieldGroup 
					name="oldPassword"
					type="password"
					custom={{
						placeholder: "Old Password"
					}}
				/>

				<InputFieldGroup 
					name="newPassword"
					type="password"
					custom={{
						placeholder: "New Password"
					}}
				/>
				
				<InputFieldGroup 
					name="newPasswordConfirm"
					type="password"
					custom={{
						placeholder: "Re-enter New Password"
					}}
				/>

				{ errorMessage && 
					<div className="password__error">
						<Card 
							color="error" 
							shadow={false}
							materialIcon="error">
							{errorMessage}
						</Card>
					</div> 
				}

				<ButtonGroup>
					<Button color="secondary">Update</Button>
				</ButtonGroup>
			</form>
		</Aux>
	);
};

const validate = values => {
	const errors = {};

	if (!values.oldPassword) {
		errors.oldPassword = "You must fill in your old password.";
	}

	if(values.newPassword && values.newPassword.length < 6) {
		errors.newPassword = "Your password must be a minimum of 6 characters";
	}

	if (!values.newPassword) {
		errors.newPassword = "You must fill in a new password.";
	}

	if (!values.newPasswordConfirm) {
		errors.newPasswordConfirm = "You must fill in a new password.";
	}

	if (values.newPassword !== values.newPasswordConfirm) {
		errors.newPasswordConfirm = "New Passwords do not match.";
	}

	return errors;
}

export default reduxForm({
	form: 'passwordForm',
	validate,
})(PasswordForm);


// WEBPACK FOOTER //
// ./src/components/routes/Settings/PasswordForm.js